export var PortariaRatificacaoUrbanaEnum;
(function (PortariaRatificacaoUrbanaEnum) {
    PortariaRatificacaoUrbanaEnum["PORTARIA_083_2018"] = "PORTARIA_083_2018";
    PortariaRatificacaoUrbanaEnum["PORTARIA_82_08"] = "PORTARIA_82_08";
    PortariaRatificacaoUrbanaEnum["PORTARIA_192_14"] = "PORTARIA_192_14";
})(PortariaRatificacaoUrbanaEnum || (PortariaRatificacaoUrbanaEnum = {}));
(function (PortariaRatificacaoUrbanaEnum) {
    var mapDescricao = new Map([
        [PortariaRatificacaoUrbanaEnum.PORTARIA_083_2018, 'Portaria Nº 083/2018'],
        [PortariaRatificacaoUrbanaEnum.PORTARIA_82_08, 'Portaria Nº 82/2008'],
        [PortariaRatificacaoUrbanaEnum.PORTARIA_192_14, 'Portaria Nº 192/2014'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    PortariaRatificacaoUrbanaEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    PortariaRatificacaoUrbanaEnum.getOptions = getOptions;
})(PortariaRatificacaoUrbanaEnum || (PortariaRatificacaoUrbanaEnum = {}));
